import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_LANGUAGE, TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service';
import { WebApiService } from '../../../shared/service/webapi.service';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-AddProxy-Multiple',
  templateUrl: './AddProxy-Multiple.component.html'
})
export class AddProxyMultipleComponent extends BaseComponent implements OnInit {
  @Input() isEdit: boolean = false;
  @Input() editData: any;
  @Input() isAdd: boolean = false;

  loading: boolean = false;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  validateForm: FormGroup;
  fileList: NzUploadFile[] = [];
  pageSize: number = 20;
  dateNow: any = this.getTheDateStringforMMDD();
  pageIndex: number = 1;
  listOfData: any[] = [];
  nzTotal: number = 0;
  formValues: any;
  type: string;
  userOptionList = [];

  tabIndex: number = 0;
  @Input() set index(value) {
    if (!!value || value === 0) {
      this.tabIndex = value;
    }
  };

  constructor(private authService: AuthService,
    private webApiService: WebApiService,
    private translate: TranslateService,
    private messageService: NzMessageService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private Environment: EnvironmentconfigService,
    private NzMessageService: NzMessageService,
    private WebApiService: WebApiService,
    private fb: FormBuilder,
    private AuthService: AuthService,
    private http: HttpClient) { super(); }

  ngOnInit() {
    //this.validateForm = this.fb.group({
    //OrderType: [''],
    //});
    this.validateForm = this.fb.group({
      buyerId: [''],
    });
    this.getResultData();
    //this.type = "0";
  }

  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();

  }

  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }
  waitProxyId = ''
  changeSelect(event) {
    if (Boolean(event)) {
      this.waitProxyId = event
    } else {
      this.waitProxyId = null;
    }
    this.getResultData()
  }

  getResultData() {
    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetProxyHistory.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        EmployeeID: (this.authService.getCurrentUserInfo()?.userId ?? ''),
        HavePono: true,
        UserId: this.waitProxyId
        //type:this.validateForm.controls['OrderType'].value==''?"0":this.validateForm.controls['OrderType'].value,
      },
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {

        if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
          this.listOfData = res.data.map((item) => {
            item.startDate = this.getTheDateString_(item.startDate);
            item.endDate = this.getTheDateString_(item.endDate);
            return item;
          });
          this.nzTotal = res.total;
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.messageService.warning(res.msg);
        }

        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
      }
    );
  }

  onEdit(data) {
    this.editData = { ...data };
    this.isEdit = true;
  }

  closeAdd() {
    this.isAdd = false;
    this.isEdit = false;
  }

  saveEdit(event) {
    this.editData = null;
    this.modifyData(
      `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.EditProxyEndDate.url}`,
      event
    );
  }

  modifyData(url, data) {
    this.loading = true;
    const params = {
      data: {
        EmployeeID: data.EmployeeID,
        ProxyID: data.ProxyID,
        Pono: data.PoNo,
        StartDate: this.getTheDateString_(data.StartDate),
        EndDate: this.getTheDateString_(data.EndDate),
        OldProxyID: data.OldProxyID,
        OldStartDate: this.getTheDateString_(data.OldStartDate),
        OldEndDate: this.getTheDateString_(data.OldEndDate),
        Remark: data.Remark || '',
        ProxyName: data.ProxyName,
        Function: data.Function
      },
    };
    this.webApiService.doPost(url, params).subscribe((res) => {
      if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
        this.messageService.success(res.msg);
        this.getResultData();
        this.isEdit = false;
      } else {
        this.messageService.error(res.msg);
      }
      this.loading = false;
    });
  }

  GetCancelFlag(value) {
    this.cancelData(
      `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.CancelProxy.url}`, value);
  }

  cancelData(url, data) {
    this.loading = true;
    const params = {
      data: {
        EmployeeID: data.EmployeeID,
        ProxyID: data.ProxyID,
        StartDate: this.getTheDateString_(data.StartDate),
        Pono: data.PoNo
      },
    };
    this.webApiService.doPost(url, params).subscribe((res) => {
      if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
        this.messageService.success(res.msg);
        this.getResultData();
        this.isEdit = false;
      } else {
        this.messageService.error(res.msg);
      }
      this.loading = false;
    });
  }
  //Excel
  exportTableToExecl() {
    this.loading = true;
    const params = {
      data: {
        Language: sessionStorage.getItem("wmsmlang"),
        UserId: this.validateForm.controls['buyerId'].value,
        //type:this.validateForm.controls['OrderType'].value==''?"0":this.validateForm.controls['OrderType'].value,
      },
    };
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.DownLoadProxyExcel.url}`;
    this.webApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `Multi_Proxy_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file);
    return false;
  };

  userSearch(event) {
    this.loading = true
    event = event.trim().toUpperCase();
    if (event.length > 5) {
      const url = `${this.Environment.authConfig.MVMBackEnd}${URLConst.QueryUser.url}` + event;
      setTimeout(() => {
        this.WebApiService.doGet(url).toPromise().then(
          (res) => {
            this.loading = true;
            this.userOptionList = res.data.slice(0, 10);
            this.loading = false
          },
          (error) => {
            this.NzMessageService.error(error.msg);
            this.loading = false
          }
        );
      }, 800);

    }
    this.loading = false
  }

  saveExcelData(file) {
    this.loading = true;

    if (!this.ExcelControl.includes(file.type)) {
      this.messageService.warning(
        this.translate.instant('Prompt.MustUploadExcelFile')
      );
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('Type', '');  //後端會重取
    //formData.append('emplid', this.authService.userInfo.emplid);
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.UploadMultiProxyExcel.url}?emplid=` + this.AuthService.getCurrentUserInfo()?.userId;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.authService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          if (res['body'].status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
            this.getResultData();
            this.messageService.success(res['body'].msg);
          } else {
            this.messageService.warning(res['body'].msg);
          }
          this.loading = false;
        },
        (error) => {
          this.messageService.error('upload failed.');
          this.loading = false;
        }
      );
  }
}


